import { type FC, useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { BLUR_COMMAND, FOCUS_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical';

interface Props {
  onFocus: () => void;
  onBlur: () => void;
}

export const LexicalFocusObserver: FC<Props> = (props) => {
  const { onFocus, onBlur } = props;

  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        BLUR_COMMAND,
        () => {
          onBlur();
          return false;
        },
        COMMAND_PRIORITY_LOW,
      ),
    [editor, onBlur],
  );

  useEffect(
    () =>
      editor.registerCommand(
        FOCUS_COMMAND,
        () => {
          onFocus();
          return false;
        },
        COMMAND_PRIORITY_LOW,
      ),
    [editor, onFocus],
  );

  return null;
};
